// extracted by mini-css-extract-plugin
export default {"input":"TextInput_input__Mtv37","input_focus":"TextInput_input_focus__OEuEG","error":"TextInput_error__u1KcN","error_text":"TextInput_error_text__xUR6-"};